import { createFileRoute } from "@tanstack/react-router";
import { MessageSquareHeartIcon } from "lucide-react";
import { FeedbackList } from "@/components/admin/feedback/feedback-list";
import { requireAdminSection } from "@/lib/admin-guard";

export const Route = createFileRoute("/_admin/feedback")({
  beforeLoad: ({ context }) => requireAdminSection(context.auth.capabilities, "support_feedback"),
  component: AdminFeedbackPage,
});

function AdminFeedbackPage() {
  return (
    <div className="flex flex-1 flex-col gap-8 p-6">
      <header className="flex flex-col gap-2">
        <div className="flex items-center gap-2 font-medium text-muted-foreground text-xs uppercase tracking-wider">
          <MessageSquareHeartIcon className="size-3.5" />
          Support
        </div>
        <div className="flex flex-col gap-1">
          <h1 className="font-heading font-semibold text-3xl tracking-tight">Feedback</h1>
          <p className="max-w-2xl text-muted-foreground text-sm">
            What users tell you through the in-app “How’s your experience?” dialog — sentiment,
            comments, and where they were when they sent it. Triage each item as you work through
            them.
          </p>
        </div>
      </header>

      <FeedbackList />
    </div>
  );
}
